/* unplugin-vue-components disabled */import { render } from "./CheatMask.vue?vue&type=template&id=f4131b1a&scoped=true&ts=true"
import script from "./CheatMask.vue?vue&type=script&lang=ts"
export * from "./CheatMask.vue?vue&type=script&lang=ts"

import "./CheatMask.vue?vue&type=style&index=0&id=f4131b1a&lang=less&scoped=true"
import "./CheatMask.vue?vue&type=style&index=1&id=f4131b1a&lang=less"

import exportComponent from "/work/release/ug-fe-contest-student/node_modules/.pnpm/vue-loader@16.7.0_@vue+compiler-sfc@3.2.23_vue@3.2.23_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4131b1a"]])